import { AxiosResponse } from 'axios';
import ApiService from './api.service';
import { SuperAdminEndpoint } from './api.endpoints';
import { UserLogin } from '../types';

class SuperAdminService extends ApiService {
  async superAdminLogin(payload: UserLogin): Promise<AxiosResponse | undefined> {
    const response = await this.post(SuperAdminEndpoint.LOGIN, payload);
    return response;
  }

  async fetchAllBrands(): Promise<AxiosResponse | undefined> {
    const response = await this.get(SuperAdminEndpoint.BRANDS);
    return response;
  }

  async loadSuperAdmin(): Promise<AxiosResponse | undefined> {
    const response = await this.get(SuperAdminEndpoint.LOAD);
    return response;
  }
}

export default SuperAdminService;
